/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react'
import Logo from './logo'
import { Drawer, Menu } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import {HomeOutlined } from '@ant-design/icons';
import { FaCartPlus, FaServicestack, FaSubscript, FaTags, FaUser, FaUserGroup } from 'react-icons/fa6';
import { BiSolidBook, BiSolidCheckSquare, BiSolidReport } from 'react-icons/bi';
import { CiSettings } from 'react-icons/ci';
import { FaToolbox } from 'react-icons/fa';
import { useRecoilValue } from 'recoil';
import authAtom from '../atoms/auth/auth.atom';

function Sidebar({
  isOpen,
  onClose,
}) {
  const { pathname } = useLocation()

  const { user } = useRecoilValue(authAtom)

  // const {user?.role?.permissions} = user && user?.role?.
  
// userType !== "InsuranceCompany"?:
  const items = useMemo(() => [
    {
      key: "/",
      label: <Link to="/">Dashboard</Link>,
      icon: <HomeOutlined style={{ fontSize: '20px', color: '#9e005d' }} />,
      //<img alt='dashboard' src={dashboardIcon} />,
    },
    user?.role?.permissions.find((permit) => permit.name === "CanViewUsers") && 
    {
      key: "/admin-management",
      label: <Link to="/admin-management">Admin Management</Link>,
      icon: <FaUser style={{ fontSize: '20px', color: '#9e005d' }} />
      // <img alt='user management' src={userIcon} />,
    },
    user?.role?.permissions.find((permit) => permit.name === "CanViewUsers") && 
    {
      key: "/user-management",
      label: <Link to="/user-management">User Management</Link>,
      icon: <FaUserGroup style={{ fontSize: '20px', color: '#9e005d' }} />
      // <img alt='user management' src={userIcon} />,
    },
    user?.role?.permissions.find((permit) => permit.name === "CanViewProducts") && 
    {
      key: "/products-management",
      label: <Link to="/products-management">Category</Link>,
      icon: <FaCartPlus style={{ fontSize: '20px', color: '#9e005d' }} />
      // <img alt='event management' src={eventIcon} />,     
    },
    user?.role?.permissions.find((permit) => permit.name === "CanViewBrands") && 
    {
      key: "/brands-management",
      label: <Link to="/brands-management">Brand Management</Link>,
      icon: <FaTags style={{ fontSize: '20px', color: '#9e005d' }} />
    },
    user?.role?.permissions.find((permit) => permit.name === "CanViewAds") && 
    {
      key: "/ads-services",
      label: <Link to="/ads-services">Ads Services</Link>,
      icon: <FaServicestack style={{ fontSize: '20px', color: '#9e005d' }} />
    },
    user?.role?.permissions.find((permit) => permit.name === "CanViewDevices") && 
    {
      key: "/devices-management",
      label: <Link to="/devices-management">Devices Management</Link>,
      icon: <FaToolbox style={{ fontSize: '20px', color: '#9e005d' }} />
    },
    user?.role?.permissions.find((permit) => permit.name === "CanViewDisputes") && 
    {
      key: "/dispute-management",
      label: <Link to="/dispute-management">Disputes Management</Link>,
      icon: <FaToolbox style={{ fontSize: '20px', color: '#9e005d' }} />
    },
    user?.role?.permissions.find((permit) => permit.name === "CanViewBusinessAccounts") && 
    {
      key: "/business-management",
      label: <Link to="/business-management">Business Management</Link>,
      icon: <FaTags style={{ fontSize: '20px', color: '#9e005d' }} />
    },
    user?.role?.permissions.find((permit) => permit.name === "CanViewBlogs") && 
    {
      key: "/blogs",
      label: <Link to="/blogs">Blog Management</Link>,
      icon: <BiSolidCheckSquare style={{ fontSize: '20px', color: '#9e005d' }} />
      // <img alt='invitee management' src={galleryIcon} />,
    },
    user?.role?.permissions.find((permit) => permit.name === "CanViewModels") && 
    {
      key: "/models-management",
      label: <Link to="/models-management">Model Management</Link>,
      icon: <FaTags style={{ fontSize: '20px', color: '#9e005d' }} />
      // <img alt='invitee management' src={galleryIcon} />,
    },
    user?.role?.permissions.find((permit) => permit.name === "CanViewSubscriptions") && 
    {
      key: "/subscription-management",
      label: <Link to="/subscription-management">Subscription Management</Link>,
      icon: <FaSubscript style={{ fontSize: '20px', color: '#9e005d' }} />
      // <img alt='event  gallery' src={galleryIcon} />,
    },
    user?.role?.permissions.find((permit) => permit.name === "CanViewInsuranceManagements") && 
    {
      key: "/insurance-management",
      label: <Link to="/insurance-management">Insurance Management</Link>,
      icon: <BiSolidCheckSquare style={{ fontSize: '20px', color: '#9e005d' }} />
      // <img alt='qr codes' src={barcodeIcon} />,
    },
    {
      key: "/reports",
      label: <Link to="/transactions">Transactions</Link>,
      icon: <BiSolidReport style={{ fontSize: '20px', color: '#9e005d' }} />
      // <img alt='qr codes' src={barcodeIcon} />,
    },
    user?.role?.permissions.find((permit) => permit.name === "CanViewFaq") && 
    {
      key: "/faqs",
      label: <Link to="/faqs">FAQs Management</Link>,
      icon: <BiSolidBook style={{ fontSize: '20px', color: '#9e005d' }} />
      // <img alt='qr codes' src={barcodeIcon} />,
    },
    {
      key: "/settings",
      label: <Link to="/settings">Settings</Link>,
      icon: <CiSettings style={{ fontSize: '20px', color: '#9e005d' }} />
      // <img alt='settings' src={settingIcon} />,
    },
  ], []);

  const itemss = useMemo(() => [
    {
      key: "/",
      label: <Link to="/">Dashboard</Link>,
      icon: <HomeOutlined style={{ fontSize: '20px', color: '#9e005d' }} />,
      //<img alt='dashboard' src={dashboardIcon} />,
    },
    {
      key: "/devices",
      label: <Link to="/devices">Devices Management</Link>,
      icon: <FaToolbox style={{ fontSize: '20px', color: '#9e005d' }} />
    },
    {
      key: "/admin-management",
      label: <Link to="/admin-management">Admin Management</Link>,
      icon: <FaUser style={{ fontSize: '20px', color: '#9e005d' }} />
      // <img alt='user management' src={userIcon} />,
    },
    // {
    //   key: "/package-management",
    //   label: <Link to="/package-management">Package Management</Link>,
    //   icon: <BiSolidCheckSquare style={{ fontSize: '20px', color: '#9e005d' }} />
    //   // <img alt='qr codes' src={barcodeIcon} />,
    // },
    {
      key: "/insure-transactions",
      label: <Link to="/insure-transactions">Transactions</Link>,
      icon: <BiSolidReport style={{ fontSize: '20px', color: '#9e005d' }} />
      // <img alt='qr codes' src={barcodeIcon} />,
    },
    // {
    //   key: "/faqs",
    //   label: <Link to="/faqs">FAQs Management</Link>,
    //   icon: <BiSolidBook style={{ fontSize: '20px', color: '#9e005d' }} />
    //   // <img alt='qr codes' src={barcodeIcon} />,
    // },
    {
      key: "/settings",
      label: <Link to="/settings">Settings</Link>,
      icon: <CiSettings style={{ fontSize: '20px', color: '#9e005d' }} />
      // <img alt='settings' src={settingIcon} />,
    },
  ], []);


const Content = () => (<div className='w-full h-full overflow-y-auto md:p-5 lg:px-2 space-y-5'>
    <Logo className="!text-2xl !text-white" />
    <Menu
      style={{ border: 0, color: "#91B3E6", fontSize: "14px", fontWeight: "600", background: "transparent" }}
      defaultSelectedKeys={[pathname]}
      defaultOpenKeys={[pathname]}
      mode="inline"
      items={user?.userType === 'InsuranceCompany' ? itemss:items}
    />
  </div>)
  return (
    <div className='w-0 md:w-[20%] lg:w-[18%] z-20 bg-dark_blue border'>
      <Content />
      <Drawer
        width={270}
        placement="left"
        onClose={onClose}
        closable={false}
        open={isOpen}
      >
        <Content />
      </Drawer>
    </div>
  )
}

export default Sidebar